<template>
  <v-navigation-drawer
    v-model="drawer"
    class="nav-drawer"
    app
    width="270"
    @input="drawerClose"
    :mobile-breakpoint="SIDEBAR_MOBILEBREAKPOINT_WIDTH"
  >
    <v-app-bar class="thick-border-top" fixed clipped-top>
      <v-toolbar-title class="mr-5 align-center">
        <v-img :src="require('@/assets/img/logo.png')" class="ma-2" contain height="40" />
      </v-toolbar-title>
    </v-app-bar>

    <v-layout class="nav-content">
      <v-layout class="nav-inner-content pl-0">
        <v-list dense expand>
          <v-list-group :value="true" no-action v-if="items.main.filter((i) => i.show == true).length > 0">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_main_menu") }}</v-list-item-title>
            </template>

            <!-- MAIN -->
            <span v-for="item in items.main" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <!-- MORE -->
          <v-list-group v-model="sb_more_toggle" no-action v-if="items.more.filter((i) => i.show == true).length > 0">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_more_menu") }}</v-list-item-title>
            </template>

            <span v-for="item in items.more" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <!-- TEMPLATE -->
          <v-list-group :value="false" no-action v-if="items.templates.filter((i) => i.show == true).length > 0">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_template_menu") }}</v-list-item-title>
            </template>

            <span v-for="item in items.templates" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <!-- EQUIPMENTS -->
          <v-list-group :value="false" no-action v-if="items.equipments.filter((i) => i.show == true).length > 0">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("equipments.title") }}</v-list-item-title>
            </template>

            <span v-for="item in items.equipments" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>

          <!-- ADMIN -->
          <v-list-group :value="false" no-action v-if="items.admin.filter((i) => i.show == true).length > 0">
            <template v-slot:activator>
              <v-list-item-title class="mt-3 sb-header">{{ $t("global.sb_admin_menu") }}</v-list-item-title>
            </template>

            <span v-for="item in items.admin" :key="item.text" class="sb-item">
              <v-list-item
                v-if="item.show && !item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                    <span v-if="item.module == 'changelog' && changeLogNewVersion" class="font-weight-black red--text">(N)</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SUBITEM -->
              <v-list-group
                no-action
                v-if="item.show && item.children"
                @click="redirect(item.path)"
                :class="item.module == currentModule ? 'active' : ''"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  @click="subitem.path ? redirect(subitem.path) : null"
                  :class="subitem.module == currentModule ? 'active' : ''"
                >
                  <v-list-item-icon>
                    <v-icon>{{ subitem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>
        </v-list>
      </v-layout>
    </v-layout>
    <!-- <span class="version">{{ $getAppVersion() }}</span> -->
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue"

export default {
  name: "Sidebar",

  data() {
    return {
      sb_more_toggle: Boolean(Number(this.$getSetting("sidebar_toggle_more"))),
      dataEnabledEmails: [
        "aevin.rabago@gmail.com",
        "vitali@avalia.no",
        "larsnordvik@outlook.com",
        "vidar@miwi.no"
      ]
    }
  },

  created() {
    let navdrawer = Boolean(window.innerWidth >= this.SIDEBAR_MOBILEBREAKPOINT_WIDTH)
    this.$toggleDrawer(navdrawer)

    if (this.$hasNewVersionChangeLog()) {
      this.$store.dispatch("master/setChangeLogNewVersion", true)
    }
  },

  computed: {
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    organisation: {
      get() {
        return this.$store.getters["organisations/organisation"]
      }
    },
    currentModule: {
      get() {
        return this.$store.getters["master/currentModule"]
      }
    },
    changeLogNewVersion() {
      return this.$store.getters["master/changeLogNewVersion"]
    },
    items: {
      get() {
        return {
          main: [
            {
              icon: "dashboard",
              text: this.$i18n.t("dashboard.title"),
              path: "dashboard",
              module: "dashboard",
              show: !this.$hasRole("company", true)
            },
            {
              icon: "how_to_reg",
              text: this.$t("enrolments.title"),
              path: "enrolments",
              module: "enrolments",
              show: this.$can("enrolment-access")
            },
            {
              icon: "book",
              text: this.$t("courses.title"),
              path: "courses",
              module: "courses",
              show: this.$can("course-access")
            },
            {
              icon: "book",
              text: this.$t("courses.longrun_title"),
              path: "courses/longrun",
              module: "courses-longrun",
              show: this.$can("course-access")
            },
            {
              icon: "perm_identity",
              text: this.$t("participants.title"),
              path: "participants",
              module: "participants",
              show: this.$can("participant-access")
            },
            {
              icon: "speaker_group",
              text: this.$t("studentgroups.title"),
              path: "studentgroups",
              module: "studentgroups",
              show: this.$can("studentgroup-access")
            },
            {
              icon: "domain",
              text: this.$t("enrolments.title_companies"),
              path: "enrolments/organisations",
              module: "enrolments-organisation",
              show: this.$can("enrolment-access") || this.$can("companies-access")
            },
            /*{
              icon: "menu_book",
              text: this.$t("global.manuals"),
              path: "manuals",
              module: "manuals",
              show: !this.$hasRole("company", true)
            }*/
          ],
          more: [
            {
              icon: "construction",
              text: this.$t("equipments.title"),
              path: "equipments",
              module: "equipments",
              show: this.$can("equipment-access")
            },
            {
              icon: "library_books",
              text: this.$t("tasks.title"),
              path: "tasks",
              module: "tasks",
              show: this.$can("task-access")
            },
            {
              icon: "drive_eta",
              text: this.$t("drivingtests.title"),
              path: "drivingtests",
              module: "drivingtests",
              show: this.$can("drivingtest-access")
            },
            {
              icon: "menu_book",
              text: this.$t("certificates.modulename"),
              path: "certificates",
              module: "certificates",
              show: this.$can("certificate-access")
            },
            {
              icon: "calendar_today",
              text: this.$t("calendar.title"),
              path: "calendar",
              module: "calendar",
              show: this.$can("calendar-access")
            },
            {
              icon: "leaderboard",
              text: this.$t("reports.title"),
              path: "reports",
              module: "reports",
              show: this.$can("report-access")
            }
          ],
          templates: [
            {
              icon: "group_work",
              text: this.$t("coursetypegroups.title"),
              path: "coursetypegroups",
              module: "coursetypegroups",
              show: this.$can("coursetypegroup-access")
            },
            {
              icon: "list_alt",
              text: this.$t("coursetypes.title"),
              path: "coursetypes",
              module: "coursetypes",
              show: this.$can("coursetype-access")
            },
            {
              icon: "vertical_split",
              text: this.$t("moduletemplates.title"),
              path: "moduletemplates",
              module: "moduletemplates",
              show: this.$can("moduletemplate-access")
            },
            {
              icon: "assessment",
              text: this.$t("coursetemplates.title"),
              path: "coursetemplates",
              module: "coursetemplates",
              show: this.$can("coursetemplate-access")
            },
            {
              icon: "list_alt",
              text: this.$t("checklist.properties"),
              path: "checklist/properties",
              module: "checklist-properties",
              show: this.$can("checklisttemplate-access") && this.organisation && this.organisation.checklist_status
            },
            {
              icon: "description",
              text: this.$t("checklist.forms"),
              path: "checklist/builder",
              module: "checklist-forms",
              show: this.$can("checklisttemplate-access") && this.organisation && this.organisation.checklist_status
            },
            {
              icon: "notifications",
              text: this.$t("notificationtemplates.title"),
              path: "notificationtemplates",
              module: "notificationtemplates",
              show: this.$can("notificationtemplate-access")
            },
            {
              icon: "notifications_active",
              text: this.$t("notifications.title"),
              path: "notifications",
              module: "notifications",
              //show: this.$can("notification-access")
              show:
                this.user.email == "aevin.rabago@gmail.com" || this.user.email == "vitali@avalia.no" || this.user.email == "lars@noorsi.no"
            }
          ],
          equipments: [
            {
              icon: "category",
              text: this.$t("equipmentcategories.title"),
              path: "equipment-categories",
              module: "equipmentcategories",
              show: this.$can("equipment-access")
            },
            {
              icon: "border_all",
              text: this.$t("equipmenttypes.title"),
              path: "equipment-types",
              module: "equipmenttypes",
              show: this.$can("equipment-access")
            },
            {
              icon: "style",
              text: this.$t("equipmentmanufacturers.title"),
              path: "equipment-manufacturers",
              module: "equipmentmanufacturers",
              show: this.$can("equipment-access")
            },
            {
              icon: "model_training",
              text: this.$t("equipmentmodels.title"),
              path: "equipment-models",
              module: "equipmentmodels",
              show: this.$can("equipment-access")
            }
          ],
          admin: [
            {
              icon: "domain",
              text: this.$t("organisations.title_s"),
              path: "organisations/edit",
              module: "organisations",
              show: this.$can("organisation-access")
            },
            {
              icon: "person",
              text: this.$t("users.title"),
              path: "users",
              module: "users",
              show: this.$can("user-access")
            },
            {
              icon: "home",
              text: this.$t("addresses.title"),
              path: "addresses",
              module: "addresses",
              show: this.$can("address-access")
            },
            {
              icon: "assignment",
              text: this.$t("classrooms.title"),
              path: "classrooms",
              module: "classrooms",
              show: this.$can("classroom-access")
            },
            {
              icon: "class",
              text: this.$t("classes.title"),
              path: "classes",
              module: "classes",
              show: this.$can("class-access")
            },
            {
              icon: "view_compact",
              text: this.$t("customergroups.title"),
              path: "customergroups",
              module: "customergroups",
              show: this.$can("customergroup-access")
            },
            {
              icon: "school",
              text: this.$t("educationprograms.title"),
              path: "educationprograms",
              module: "educationprograms",
              show: this.$can("educationprogram-access")
            },
            {
              icon: "recent_actors",
              text: this.$t("roles.title"),
              path: "roles",
              module: "roles",
              show: this.$can("role-access")
            },
            /*{
              icon: "vpn_key",
              text: this.$t("permissions.title"),
              path: "permissions",
              module: "permissions",
              show: this.$can("permission-access"),
            },*/
            {
              icon: "vpn_key",
              text: this.$t("passports.title"),
              path: "passports",
              module: "passports",
              show: this.$can("passport-access")
            },
            /*{
              icon: "settings",
              text: this.$t("settings.title"),
              path: "settings",
              module: "settings",
              show: this.$can("setting-access"),
            },*/
            {
              icon: "priority_high",
              text: this.$t("logs.title"),
              path: "logs",
              module: "logs",
              show: this.$can("log-access")
            },
            {
              icon: "dns",
              text: this.$t("data.title"),
              path: "data",
              module: "data",
              show: this.dataEnabledEmails.includes(this.user.email)
            },
            {
              icon: "manage_history",
              text: this.$t("changelog.title"),
              path: "changelog",
              module: "changelog",
              show: !this.$hasRole("company", true)
            }
            /*{
              icon: "queue",
              text: this.$t("queues.title"),
              path: "queues",
              module: "queues",
              show: this.$can("queue-access"),
            },*/
          ]
        }
      }
    },
    drawer: {
      get() {
        return this.$store.getters["master/drawerOpen"]
      },
      set() {}
    }
  },

  watch: {
    sb_more_toggle: {
      handler(val) {
        console.log("sidebar_toggle_more")
        this.$store.dispatch("master/setAxiosHideLoader", true)
        this.$updateSettingDB("sidebar_toggle_more", val)
      }
    }
  },

  methods: {
    redirect(to) {
      if (to) {
        if (to == "manuals") {
          window.open("https://rise.articulate.com/share/XZdHtKGCE7c9jgIyFirjxJ-VoWf4Ipmm#/", "_blank")
        } else {
          this.$router.push(this.BACKEND_URL + "/" + to)
        }
      }
    },

    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]

      return paths.some((path) => {
        return this.$router.path.indexOf(path) === 0 // current path starts with this path string
      })
    },

    drawerClose(obj) {
      if (!obj) {
        this.$store.dispatch("master/setDrawerOpen", false)
      }
    }
  }
}
</script>

<style scoped></style>
